import React from "react";
import { GenericPage } from "../../../../../pages";
import {
  malimaxOneRoute
} from "./malimax-one.route";
import {
  malimaxTwoRoute
} from "./malimax-two.route";
import {
  malimaxThreeRoute
} from "./malimax-three.route";
import {
  malimaxReportRoute
} from "./malimax-reports.route";



export const malimaxRoute = [
  {
    path: 'one',
    element: <GenericPage />,
    children:malimaxOneRoute,
  },
  {
    path: 'two',
    element: <GenericPage />,
    children:malimaxTwoRoute,
  },
  {
    path: 'three',
    element: <GenericPage />,
    children:malimaxThreeRoute,
  },
  {
    path: 'reports',
    element: <GenericPage />,
    children:malimaxReportRoute,
  },
  
]